import React, { useEffect, useMemo, useState } from 'react'
import classNames from 'classnames'
import { makeStyles } from '@material-ui/styles'
import Done from '@material-ui/icons/Done'

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    overflow: 'hidden',
    '& > *': {
      flex: 1,
      border: 0,
      backgroundColor: 'transparent',
      borderRight: '1px solid #d8d8d8',
      textAlign: 'center',
      fontWeight: 500,
      fontSize: 14,
      transition: 'box-shadow 100ms linear',
      '&:hover': {
        backgroundColor: '#0000000f',
        cursor: 'pointer',
      },
      '&:focus': {
        outline: 'none',
        boxShadow: 'inset 0 0 0 3px #0095ff8a',
      },
      '&:last-child': {
        borderRight: 'none',
      },
    },
    '@media (max-width: 960px)': {
      margin: '0 !important',
      borderTop: '1px solid #d8d8d8',
      gridColumnEnd: 'span 2',
      height: '32px',
      borderTopRightRadius: '0 !important',
      borderTopLeftRadius: '0 !important',
      borderBottomRightRadius: '10px',
      borderBottomLeftRadius: '10px',
    },
  },
  selected: {
    backgroundColor: '#15be96 !important',
  },
  doneIcon: {
    color: 'white',
  },
}))

export default function Options({
  question = {},
  userExamId = 0,
  totalHits = 0,
  handleSelectAnswer,
  answers,
}) {
  const classes = useStyles()

  const [selecteds, setSelecteds] = useState([])

  const handleSelect = (data) => {
    const answer = {
      userExam: {
        id: data.userExamId,
        lastAnsweredQuestionIndex: 0,
      },
      question: {
        id: data.question.id,
      },
      examOption: {
        id: data.option.id,
      },
    }
    handleSelectAnswer(answer, { userExamId: data.userExamId, first: totalHits || 10, after: 0 })

    const answerArr = [...answers]

    const duplicatedAnswer = answers?.find((a) => a?.question?.id === answer?.question?.id)

    if (!duplicatedAnswer) {
      answerArr.push(answer)
      setSelecteds(answerArr)
    } else {
      const duplicatedAnswerIndex = answers?.findIndex((a) => a?.question?.id
      === answer?.question?.id)
      answerArr[duplicatedAnswerIndex] = answer
      setSelecteds(answerArr)
    }
  }

  useEffect(() => {
    if (answers) {
      setSelecteds(answers)
    }
  }, [answers])

  // useEffect(() => {
  //   // setSelecteds(answers)
  //   console.log('gdhjnjn', selecteds)
  // }, [selecteds])

  // const answer = useMemo(() => answers?.find((a) => a?.question?.id
  // === question?.id), [answers])

  const answer = useMemo(() => selecteds?.find((a) => a?.question?.id
  === question?.id), [selecteds])

  return (
    <div className={classNames(classes.root)}>
      {question.options?.map((option) => (
        <button
          className={classNames({
            [classes.selected]: answer && answer.examOption.id === option.id,
          })}
            // className={classNames({
            //   [classes.selected]: answered,
            // })}
          type="button"
          key={option.id}
          onClick={() => handleSelect({ option, userExamId, question })}
        >
          {answer && answer.examOption.id
               === option.id && <Done className={classes.doneIcon} />}
          {/* {answered && <Done className={classes.doneIcon} />} */}
        </button>
      ))}

    </div>
  )
}
